import { render, staticRenderFns } from "./customField.vue?vue&type=template&id=4aed8b9d&lang=pug"
import script from "./customField.vue?vue&type=script&lang=js"
export * from "./customField.vue?vue&type=script&lang=js"
import style0 from "./customField.vue?vue&type=style&index=0&id=4aed8b9d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports